export default "__VITE_ASSET__BbnWmnzO__"